import "./DatePill.css";
import React from "react";

const DatePill = ({ label, active, count = 0, onClick, variant = "default", isSpecial = false, specialType, color, offerCount = 0 }) => {
  const has = count > 0;
  const isUrgentVariant = variant === "eve" || variant === "closest";
  const showReadyBadge = isUrgentVariant && count === 0;
  let cls = ["pill-btn", active ? "active" : ""];

  // Ajouter la classe de variant
  if (variant !== "default") {
    cls.push(`pill-${variant}`);
  }

  // Ajouter la classe spéciale
  if (isSpecial) {
    if (specialType === 'week') {
      cls.push("pill-special-week");
    } else if (specialType === 'event') {
      // Ne pas ajouter pill-special-event si on a une couleur personnalisée
      // pour éviter que le CSS orange ne s'applique
      if (!color || color === 'orange') {
        cls.push("pill-special-event");
      }
    } else {
      cls.push("pill-special");
    }
  }

  const className = cls.join(" ").trim();
  
  // Style inline pour les événements avec couleur personnalisée
  const getEventStyle = () => {
    if (!isSpecial || specialType !== 'event' || !color || color === 'orange') {
      return {};
    }

    const colorMap = {
      'green': {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        borderColor: '#059669',
        color: 'white',
      },
      'blue': {
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        borderColor: '#2563eb',
        color: 'white',
      },
      'red': {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        borderColor: '#dc2626',
        color: 'white',
      },
      'purple': {
        background: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
        borderColor: '#9333ea',
        color: 'white',
      },
    };

    const baseStyle = colorMap[color] || {};
    
    if (active) {
      // Style pour l'état actif
      return {
        ...baseStyle,
        background: baseStyle.background?.replace('100%)', '80%)') || baseStyle.background,
        opacity: 0.9,
      };
    }

    return baseStyle;
  };

  const eventStyle = getEventStyle();
  
  // Log pour déboguer
  if (isSpecial && specialType === 'event' && color) {
    console.log('🎨 [DatePill] Événement spécial:', {
      label,
      color,
      hasStyle: Object.keys(eventStyle).length > 0,
      className
    });
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-pressed={active}
      style={{ 
        position: 'relative',
        ...eventStyle,
        fontWeight: eventStyle.background ? 600 : undefined,
        borderWidth: eventStyle.borderColor ? '2px' : undefined,
        borderStyle: eventStyle.borderColor ? 'solid' : undefined,
      }}
    >
      <span style={{ whiteSpace: "nowrap" }}>{label}</span>
      <span className={["pill-count", has ? "has" : ""].join(" ").trim()}>{count}</span>
      {showReadyBadge && (
        <span
          aria-hidden
          style={{
            marginTop: 6,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            background: "#16a34a",
            color: "#fff",
            borderRadius: 999,
            padding: "2px 8px",
            fontSize: 10,
            fontWeight: 700,
            boxShadow: "0 2px 6px rgba(0,0,0,.15)",
          }}
        >
          ✅ OK
        </span>
      )}
      {offerCount > 0 && (
        <span
          aria-hidden
          style={{
            position: 'absolute',
            top: -6,
            right: -6,
            fontSize: 10,
            color: '#fff',
            fontWeight: 800,
            lineHeight: 1,
            background: '#22c55e',
            border: '2px solid #fff',
            borderRadius: 999,
            padding: '2px 6px',
            boxShadow: '0 2px 6px rgba(0,0,0,.18)',
            pointerEvents: 'none',
          }}
          title={`${offerCount} offre${offerCount>1?'s':''}`}
        >
          {offerCount}
        </span>
      )}
    </button>
  );
};

export default DatePill;
